module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5e4aba26bb06bcc0ae1357d1cfdfd678.gif";